/* eslint-disable complexity */
import React from 'react';
import { useLocation } from 'react-router-dom';

import { ROUTES } from '@futrli/shared-services';

import { BalanceSheetV2 } from '../../detail/predictions/balance-sheet/balance-sheet-v2';
import { CashFlowStatementV2 } from '../../detail/predictions/cash-flow-statement/cash-flow-statement-v2';
import { ConsolidatedForecastReportStructureWithTabs, ConsolidatedForecastReportTab } from '../../../core/types';
import { Invoices } from '../../detail/predictions/invoices/invoices';
import { PredictionsSubTabUK } from '../../detail/predictions/predictions-sub-tab/predictions-sub-tab-uk/predictions-sub-tab-uk';
import { ProfitAndLossV2 } from '../../detail/predictions/profit-and-loss/profit-and-loss-v2';
import { usePredictionsInfoContext } from '../../detail/context/predictions-info-context';

export const OnboardingPredictionsRouter = () => {
  const { pathname } = useLocation();
  const { forecastReportV2: forecastReport } = usePredictionsInfoContext();

  const subtabs = (forecastReport?.structure as ConsolidatedForecastReportStructureWithTabs)?.tabs || [];
  const subTabsMap = subtabs.reduce((acc, tab) => {
    acc[tab.id || ''] = tab;
    return acc;
  }, {} as Record<string, ConsolidatedForecastReportTab>);

  const getPageContent = () => {
    if (pathname.includes(ROUTES.INVOICES)) {
      return <Invoices />;
    }
    if (pathname.includes(ROUTES.PROFIT_AND_LOSS)) {
      return <ProfitAndLossV2 />;
    }
    if (pathname.includes(ROUTES.BALANCE_SHEET)) {
      return <BalanceSheetV2 />;
    }
    if (pathname.includes(ROUTES.CASH_FLOW_STATEMENT)) {
      return <CashFlowStatementV2 />;
    }

    if (pathname.includes(ROUTES.SALES)) {
      return subTabsMap.sales ? <PredictionsSubTabUK tab={subTabsMap.sales} /> : null;
    }
    if (pathname.includes(ROUTES.COSTS)) {
      return subTabsMap.costs ? <PredictionsSubTabUK tab={subTabsMap.costs} /> : null;
    }
    if (pathname.includes(ROUTES.EXPENSES)) {
      return subTabsMap.expenses ? <PredictionsSubTabUK tab={subTabsMap.expenses} /> : null;
    }
    if (pathname.includes(ROUTES.OTHER_P_AND_L)) {
      return subTabsMap.other_p_and_l ? <PredictionsSubTabUK tab={subTabsMap.other_p_and_l} /> : null;
    }
    if (pathname.includes(ROUTES.ASSETS)) {
      return subTabsMap.assets ? <PredictionsSubTabUK tab={subTabsMap.assets} /> : null;
    }
    if (pathname.includes(ROUTES.LIABILITIES)) {
      return subTabsMap.liabilities ? <PredictionsSubTabUK tab={subTabsMap.liabilities} /> : null;
    }
  };
  return <div>{getPageContent()}</div>;
};
